import gql from 'graphql-tag';

export const removeLocationMutation = gql`
  mutation RemoveLocation($id: ID!) {
    removeLocation(id: $id)
  }
`;